import { LogIn, WifiOff } from 'lucide-react'

import { useAuth } from './authContext'

/** Anmeldeschirm und Fehleranzeige, bevor die App überhaupt Daten zeigt. */
export function LoginScreen() {
  const { status, error, signIn } = useAuth()

  if (status === 'error') {
    return (
      <div className="mittig">
        <h1>Das Roadbook kann nicht starten</h1>
        <p>{error}</p>
        {/*
          Ein blosses Neuladen genügt hier nicht: scheitert die Einlösung des
          Authorization Code, ist der Code verbraucht und der Signin-State weg.
          Ein zweiter Anlauf muss deshalb bei der Anmeldung selbst beginnen.
        */}
        <div className="knopfreihe">
          <button type="button" className="knopf" onClick={() => void signIn()}>
            <LogIn size={15} /> Erneut anmelden
          </button>
          <button type="button" className="knopf still" onClick={() => window.location.reload()}>
            Neu laden
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="mittig">
      <h1>Roadbook</h1>
      <p>
        Etappen, Tagebuch und Budget einer Reise. Die Anmeldung läuft über den eigenen
        Anmeldedienst; danach liegen die Daten auf dem Gerät und werden im Hintergrund abgeglichen.
      </p>
      <button type="button" className="knopf" onClick={() => void signIn()}>
        <LogIn size={15} /> Anmelden
      </button>
      {/*
        Ein Anmeldeversuch kann scheitern, bevor die Weiterleitung überhaupt
        beginnt - ohne Netz erreicht signinRedirect den Anmeldedienst nicht.
        Ohne diese Zeile bliebe davon nur ein Knopf, der nichts tut. Der
        allgemeine Offline-Hinweis darunter tritt dann zurück: die Meldung des
        Versuchs ist die konkretere.
      */}
      {error && <p className="hinweis">{error}</p>}
      {!error && !navigator.onLine && (
        <p className="hinweis">
          <WifiOff size={13} /> Ohne Verbindung ist keine erste Anmeldung möglich. Melde dich einmal
          im Netz an, danach läuft die App auch offline.
        </p>
      )}
    </div>
  )
}
